const HOTSPOTICONTYPE = "default"
// const HOTSPOTICONTYPE = "individual"
const HOTSPOTSDATA = 
    [
        {
            'name': 'Engine',
            'description' : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, quam?',
            'iconImageName': 'piston',
            'position' : {
                'x' : '.33',
                'y' : '-0.2',
                'z' : '.11'
            }
        },
        {
            'name': 'Comfort',
            'description' : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, quam?',
            'iconImageName': 'suspension',
            'position' : {
                'x' : '-.32',
                'y' : '0.2',
                'z' : '0.2'
            }
        },
        {
            'name': 'Technology',
            'description' : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, quam?',
            'iconImageName': 'microchip',
            'position' : {
                'x' : '0',
                'y' : '.2',
                'z' : '-0.3'
            }
        },

    ]

export {HOTSPOTSDATA, HOTSPOTICONTYPE}